import { api } from '../../utils';

const reportsBaseApi = 'reports';

class ModuleApi {
  fetchBuildingReport(buildingId: number, fromDate: number) {
    return api.post(`${reportsBaseApi}/last2weeks-summary`, { buildingId, fromDate });
  }

  getRoomsReport({ beginDate, endDate, buildingId }: { beginDate: number; endDate: number; buildingId: number }) {
    return api.post(`${reportsBaseApi}/overall-rooms`, {
      beginDate,
      endDate,
      buildingId
    });
  }

  getGraphReport({ beginDate, endDate, buildingId }: { beginDate: number; endDate: number; buildingId: number }) {
    return api.post(`${reportsBaseApi}/overall-graph`, {
      beginDate,
      endDate,
      buildingId
    });
  }

  report24h(fromDate: number) {
    return api.post(`${reportsBaseApi}/24h`, { fromDate });
  }

  devicesAvailability() {
    return api.get('devices/availability');
  }

  getAlarms() {
    return api.get('alarms/latest');
  }

  getRoomDataById(id: string) {
    return api.get(`rooms/${id}`);
  }

  getAlarmsDataByDate(id: string) {
    return api.get(`alarms/by-room/${id}`);
  }

  getAlarmsByRoom(id: string) {
    return api.get(`alarms/latest/by-room/${id}`);
  }

  getRoomMeasurementsById(id: string, beginDate: string, endDate: string) {
    return api.post(`${reportsBaseApi}/room-by-day/${id}`, { beginDate, endDate });
  }

  getRoomMeasurements10MinGranularityById(id: string, beginDate: number, endDate: number) {
    return api.post(`${reportsBaseApi}/room/${id}`, { beginDate, endDate });
  }
}

export default new ModuleApi();
